import React from "react";

const Privacy = () => (
  <div style={{ maxWidth: 700, margin: "40px auto", padding: "24px", background: "#fff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(44,62,80,0.08)" }}>
    <h1 style={{ fontSize: "2rem", marginBottom: "18px" }}>Privacy Policy</h1>
    <p>
      <strong>Effective Date:</strong> September 15, 2025
    </p>
    <p>0249527057
1. Introduction
Welcome to HuntexLotto.com, the innovative online lotto-staking platform. This Privacy Policy outlines how HuntexLotto.com
collects, uses, and safeguards your personal information. By using our website or app, you agree to the terms of this policy.    </p>
    <h2>Information We Collect</h2>
    <ul>
      <li><strong>Personal Information:</strong> Name, phone number, email address, and payment details.</li>
      <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
      <li><strong>Cookies:</strong> We use cookies to enhance your experience.</li>
    </ul>
    <h2>How We Use Your Information</h2>
    <ul>
      <li>To provide and maintain our services</li>
      <li>To process transactions and send notifications</li>
      <li>To improve our platform and customer support</li>
      <li>To comply with legal obligations</li>
    </ul>
    <h2>Information Sharing</h2>
    <p>
      We do not sell or rent your personal information. We may share your data with trusted third parties for service delivery, compliance, or as required by law.
    </p>
    <h2>Your Choices</h2>
    <ul>
      <li>You may update or correct your information at any time.</li>
      <li>You may opt out of marketing communications.</li>
    </ul>
    <h2>Security</h2>
    <p>
      We use industry-standard security measures to protect your data. However, no method of transmission over the Internet is 100% secure.
    </p>
    <h2>Contact Us</h2>
    <p>
      If you have questions about this Privacy Policy, please contact us at <a href="mailto:contactus@huntexlotto.com">contactus@huntexlotto.com</a>.
    </p>
    <p style={{ marginTop: "32px", color: "#888" }}>
      © 2025 HuntexLotto. All Rights Reserved.
    </p>
  </div>
);

export default Privacy;